export const SENTRY_MIDDLEWARE = 'MIDDLEWARE';
